import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { map } from 'rxjs';
import { concatLatestFrom } from '@ngrx/operators';
import { quizActions } from '@app/store/quiz/actions/quiz.actions';
import { quizzesActions } from '../actions/quizzes.actions';
import { selectLastParams } from '../selectors/quizzes.selector';

@Injectable()
export class QuizQuizzesBridge {
    private readonly actions = inject(Actions);
    private readonly store = inject(Store);

    refreshOnMutation$ = createEffect(() => {
        return this.actions.pipe(
            ofType(quizActions.createQuizSuccess, quizActions.updateQuizSuccess, quizActions.deleteQuizSuccess),
            concatLatestFrom(() => this.store.select(selectLastParams)),
            map(([, lastParams]) => quizzesActions.getQuizzes({ value: lastParams })),
        );
    });
}
